import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {CrewMessagerConfig, CrewMessager} from "./crew_messager"

export const crewMessagerLoader = function (options = {}) {
    componentLoader(componentConfig(CrewMessager, CrewMessagerConfig.componentTypeKey, CrewMessagerConfig.baseHtmlClass), options);
};

